export const trabajos = [
    {
        'id': 'proj1',
        'nombre': 'Cinéfilo',
                'url': 'https://play.google.com/store/apps/details?id=com.enriquediazweb.cinefilo&hl=en-US&ah=aRUmgybnA9C86EguemrK_Qe0UUA&pli=1',
        'tecnologia': 'Applicacion flutter',
        'imagen': 'galeria-1.jpg',
        'categoria': 'movil',
        'icono': 'fa-solid fa-mobile',
        'descripcion': ' Te ofrece toda la información sobre películas, actores, directores, críticas y estrellas, además de permitirte crear listas de favoritos y recibir las mejores recomendaciones.'
    },
    {
        'id': 'proj2',
        'nombre': 'API Tienda teslo',
        'url': 'https://teslo-shop-suic.onrender.com/Api',
        'tecnologia': 'NodeJS',
        'imagen': 'galeria-2.jpg',
        'categoria': 'Api',
        'icono': 'fa-solid fa-database',
        'descripcion': 'Es la Api que publica la Base de datos de la ropa con sus caracteristicas'
    },
    {
        'id': 'proj3',
        'nombre': 'Tiendo teslo',
        'url': 'https://tesloshop-gc.vercel.app/',
        'tecnologia': 'React javascript CSS HTML',
        'imagen': 'galeria-3.jpg',
        'categoria': 'WEB',
        'icono': 'fa-solid fa-window-restore',
        'descripcion': 'La pagina web que permite al usuario interactuar con la lista de ropa que desea comprar'
    },
    {
        'id': 'proj4',
        'nombre': 'Agencia de Desarrollo',
        'url': 'https://portafolio.enriquediazweb.com/agencia/index.html',
        'tecnologia': 'javascript CSS HTML',
        'imagen': 'galeria-4.jpg',
        'categoria': 'WEB',
        'icono': 'fa-solid fa-window-restore',
        'descripcion': 'La pagina Web de una agencia de desarrollo de aplicaciones que ofrece sus servicios, permite el modo dark y responde al tamaño de la pantalla'
    },
    {
        'id': 'proj5',
        'nombre': 'wordpress web page',
        'url': 'https://enriquediazweb.com/',
        'tecnologia': 'wordpress',
        'imagen': 'galeria-5.jpg',
        'categoria': 'WEB',
        'icono': 'fa-solid fa-window-restore',
        'descripcion': 'Mi página Personal desarrollada y administrada en wordpress, que provee al usuario final de una consola de administración amigable '
    },
    {
        'id': 'proj6',
        'nombre': 'API red social',
        'url': 'https://enriquediazweb.com/',
        'tecnologia': 'Node Express y Mongo DB',
        'imagen': 'galeria-6.jpg',
        'categoria': 'API REST',
        'icono': 'fa-solid fa-database',
        'descripcion': 'Una Aplicación web similar a una red social en la cual los usuario publican y existen seguidores, publicadores, etc'
    }
]